import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Link } from 'react-router';
import * as libraryActions from '~/library/actions';
import ArtifactHelper from '~/utils/ArtifactHelper';
import StringService from '~/utils/StringService';
import { Table, Thead, Th, Tr, Td } from 'SourceClear-Reactable';
import Helpers from '~/utils/Helpers';
type LibraryViewCommitHashVulnerabilitiesProps = {
  libraryState: object;
  actions: object;
};
class LibraryViewCommitHashVulnerabilities extends React.Component<
  LibraryViewCommitHashVulnerabilitiesProps,
  {}
> {
  componentDidMount() {
    const { libraryState } = this.props;
    const {
      component,
      commitHash,
      isLoadingCommitHashVulnerabilities,
      commitHashVulnerabilityErrors = {},
    } = libraryState;
    if (commitHash && !_.isEmpty(component) && commitHashVulnerabilityErrors[commitHash]) {
      this.props.actions.maybeLoadCommitHashVulnerabilities(commitHash);
    }
    if (
      commitHash &&
      !_.isEmpty(component) &&
      !isLoadingCommitHashVulnerabilities &&
      !commitHashVulnerabilityErrors[commitHash]
    ) {
      this.props.actions.maybeLoadCommitHashVulnerabilities(commitHash);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { libraryState } = nextProps;
    const {
      component,
      commitHash,
      isLoadingCommitHashVulnerabilities,
      commitHashVulnerabilityErrors = {},
    } = libraryState;
    if (
      commitHash &&
      !_.isEmpty(component) &&
      !isLoadingCommitHashVulnerabilities &&
      !commitHashVulnerabilityErrors[commitHash]
    ) {
      this.props.actions.maybeLoadCommitHashVulnerabilities(commitHash);
    }
  }
  getFilteredVulnerabilities() {
    const { libraryState } = this.props;
    const {
      commitHash,
      vulnerabilitiesByCommitHash = {},
      commitHashVulnerabilityFilter = '',
    } = libraryState;
    let vulnerabilities = vulnerabilitiesByCommitHash[commitHash] || [];
    if (!commitHashVulnerabilityFilter) {
      return vulnerabilities;
    }
    return vulnerabilities.filter(vuln => {
      let { title = '' } = vuln;
      return title.toLowerCase().indexOf(commitHashVulnerabilityFilter) > -1;
    });
  }
  updateFilter = e => {
    const filter = e.target.value;
    this.props.actions.updateCommitHashVulnerabilityFilter(filter.toLowerCase());
  };
  render() {
    const { libraryState } = this.props;
    const {
      isLoadingCommitHashVulnerabilities = false,
      commitHashVulnerabilityFilter = '',
      commitHashVulnerabilityErrors = {},
      commitHash,
      language,
    } = libraryState;
    const isShowingCommitHash = Helpers.isCommitHashSupportedByLanguage(language);
    const commitHashText = isShowingCommitHash && commitHash ? `commit hash ${commitHash}` : ``;
    let vulnData = [];
    let filteredVulnerabilities = this.getFilteredVulnerabilities() || [],
      sortedVulns = _.sortBy(filteredVulnerabilities, vuln => {
        return vuln.nvdCvssScore || vuln.srcclrCvssScore;
      }).reverse(),
      vulnElements = [],
      headerRow,
      filterElement;
    if (isLoadingCommitHashVulnerabilities) {
      headerRow = null;
      filterElement = null;
      vulnElements = <div key="vulns-loading">Loading vulnerabilities for {commitHashText}...</div>;
    } else if (commitHashVulnerabilityErrors[commitHash]) {
      headerRow = null;
      filterElement = null;
      vulnElements = (
        <div key="vulns-load-error">Error loading vulnerabilities for {commitHashText}</div>
      );
    } else if (isShowingCommitHash && (!commitHash || !Helpers.isCommitHash(commitHash))) {
      vulnElements = <div key="vulns-load-error">Please select or enter a valid commit hash</div>;
    } else {
      sortedVulns.forEach(vuln => {
        let scoreColorLookup = {
            high: 'bg-color--danger',
            medium: 'bg-color--warning',
            low: 'bg-color--warning-light',
            none: 'opacity--3-10',
          },
          riskScore = vuln.nvdCvssScore || vuln.srcclrCvssScore || null,
          formattedRiskScore = riskScore === 10 ? riskScore : riskScore.toFixed(1),
          severity = ArtifactHelper.calculateRiskLevel(riskScore),
          formattedDisclosureDate = vuln.disclosureDate
            ? Helpers.formatDate(vuln.disclosureDate)
            : 'n/a',
          hasCVE = +vuln.cveDigits && +vuln.cveYear,
          cveElement,
          artifactUrl = StringService.createSEOVulnItemUrl(vuln.title, vuln.language, vuln.id),
          title = vuln.title,
          hasExploits = !!vuln.hasExploits;
        if (hasCVE) {
          cveElement = (
            <a
              className="inline-block link--primary"
              target="_blank"
              href={
                'https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-' +
                vuln.cveYear +
                '-' +
                vuln.cveDigits
              }
            >
              {vuln.cveYear}-{vuln.cveDigits}
            </a>
          );
        } else {
          cveElement = <div>No CVE</div>;
        }
        vulnData.push(
          <Tr key={`${vuln.id}-${vuln.title}`}>
            <Td column="severity">
              <div
                className={
                  'text--center color--white pv-- phone--pl0 phone--pr0 ' +
                  scoreColorLookup[severity]
                }
              >
                {formattedRiskScore}
              </div>
            </Td>
            <Td column="issue">
              <div className="col-9-10">
                <Link className="link--primary" to={artifactUrl}>
                  {title}
                </Link>
              </div>
            </Td>
            <Td column="disclosed">{formattedDisclosureDate}</Td>
            <Td column="cve">{cveElement}</Td>
            <Td column="exploits">{hasExploits ? 'yes' : 'no'}</Td>
          </Tr>
        );
      });
      vulnElements = (
        <Table
          className="reactable-table reactable-vulns min-height--205"
          id="reactable-vulns"
          itemsPerPage={4}
          pageButtonLimit={5}
          hideFilterInput
          noDataText="No vulnerabilities found for the commit hash."
        >
          <Thead>
            <Th column="severity" className="col-1-10">
              <strong className="font-family--gotham-bold">Severity</strong>
            </Th>
            <Th column="issue" className="col-3-5">
              <strong className="font-family--gotham-bold">Issue</strong>
            </Th>
            <Th column="disclosed" className="col-1-10">
              <strong className="font-family--gotham-bold">Disclosed</strong>
            </Th>
            <Th column="cve" className="col-1-10">
              <strong className="font-family--gotham-bold">CVE</strong>
            </Th>
            <Th column="exploits" className="col-1-10">
              <strong className="font-family--gotham-bold">Exploits</strong>
            </Th>
          </Thead>
          {vulnData}
        </Table>
      );
      filterElement = (
        <input
          name="commit-hash-vulns"
          className="col-1-3 phone--col-1-1"
          type="text"
          placeholder="Filter by issue name"
          defaultValue={commitHashVulnerabilityFilter}
          onChange={this.updateFilter}
          autoFocus
        />
      );
      if (vulnElements.length === 0) {
        headerRow = null;
        filterElement = null;
        vulnElements = <div key="vulns-none">No vulnerabilities for {commitHashText}</div>;
      }
    }
    return (
      <div className="grid pb+">
        <div className="grid__item col-1-1">{filterElement}</div>
        <div className="grid__item col-1-1">{headerRow}</div>
        <div className="grid__item col-1-1 mt">{vulnElements}</div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    libraryState: state.libraryState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(libraryActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryViewCommitHashVulnerabilities);
